import React from 'react'
import '../scss/components/section.scss'
import Header from '../components/header/header.jsx'
import Banner from '../components/banner/banner-v3'
import dataFooter from '../assets/fake-data/data-footer'
import Bottom from '../components/bottom'
import Footer from '../components/footer/footer-v2'
import SandBox from '../pages/SpeedRun/sandbox'
import { Pricing } from './Pricing/Pricing.jsx'

function Home() {
    return (
        <div className='wrapper-style' id='wrapper'>
            <Header />
            <Banner/>
            <div className='front-sndbx-wrapper'>
                <SandBox demo={true}/>
            </div>
            <Pricing type='component' theme='dark'/>
            <Footer data={dataFooter}/>
            <Bottom classection='widget-social-footer home2'/>
        </div>
    )
}

export default Home